import script from "./FinancialCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancialCenter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__